<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">Upload</h4>
</div>
<div class="modal-body">
  <div>{{ responseText || 'Creating upload task...' }}</div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-danger my-2" (click)="closeModal()">
    Close
  </button>
</div>
